import SceneWrapper from '@/modules/sceneWrapper/scripts/SceneWrapper';

/** @description Determines whether the current frame is ended. */
export default function frameEnded(frameLastTime: number): boolean
{
    return (new Date().getTime() - (frameLastTime ?? 0)) >= SceneWrapper.frameDuration;
}
